import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { TitleModalComponent } from '../../shared/components/title-modal/title-modal.component'
import { VoucherModalComponent } from '../../shared/components/voucher-modal/voucher-modal.component'
import { CityModalComponent } from '../../shared/components/city-modal/city-modal.component'
import { CountryModalComponent } from '../../shared/components/country-modal/country-modal.component'
import { StateModalComponent } from '../../shared/components/state-modal/state-modal.component'
import { SubDepartmentModalComponent } from '../../shared/components/sub-department-modal/sub-department-modal.component'
import { DepartmemtModalComponent } from '../../shared/components/departmemt-modal/departmemt-modal.component'
import { BanksModalComponent } from '../../shared/components/banks-modal/banks-modal.component'
import { EmployeeModalComponent } from '../../shared/components/employee-modal/employee-modal.component'
import { CompanyModalComponent } from '../../shared/components/company-modal/company-modal.component'
import { CartegoryModalComponent } from '../../shared/components/cartegory-modal/cartegory-modal.component'
import { CardModalComponent } from '../../shared/components/card-modal/card-modal.component'
import { BranchModalComponent } from '../../shared/components/branch-modal/branch-modal.component'
import { UomModalComponent } from '../../shared/components/uom-modal/uom-modal.component'
import { SpecializationModalComponent } from '../../shared/components/specialization-modal/specialization-modal.component'
import { SocModalComponent } from '../../shared/components/soc-modal/soc-modal.component'
import { ItemsModalComponent } from '../../shared/components/items-modal/items-modal.component'
import { GroupsModalComponent } from '../../shared/components/groups-modal/groups-modal.component'
import { OpdModalComponent } from '../../shared/components/opd-modal/opd-modal.component'
import { NationalModalComponent } from '../../shared/components/national-modal/national-modal.component'
import { AlocatedSocModalComponent } from '../../shared/components/alocated-soc-modal/alocated-soc-modal.component'
import { SalesCardModalComponent } from '../../shared/components/sales-card-modal/sales-card-modal.component'
import { OpdDetailModalComponent } from '../../shared/components/opd-detail-modal/opd-detail-modal.component'
import { SetupModalComponent } from '../../shared/components/setup-modal/setup-modal.component'
import { RefDoctorModalComponent } from '../../shared/components/ref-doctor-modal/ref-doctor-modal.component'
import { AuthServiceService } from '../../core/http/auth-service.service';
import { SettingsService } from '../../core/http/settings.service'
import {MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DropDownComponent } from '../../shared/components/drop-down/drop-down.component'
import { AppointmentComponent } from '../../shared/components/appointment/appointment.component'
import { OfflineAppointmentComponent } from '../../shared/components/offline-appointment/offline-appointment.component'
import { CreateAppointmentComponent } from '../../shared/components/create-appointment/create-appointment.component'



@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {

  data;
  role = localStorage.getItem('role');


  constructor(private modal: ModalService, public router: Router, public setting: SettingsService, private _snackBar: MatSnackBar, public auth: AuthServiceService) { }

  openVoucher() {
    this.modal.openModal(VoucherModalComponent, 'modal');
  }
  openTitle() {
    this.modal.openModal(TitleModalComponent, 'modal');
  }
  openCity() {
    this.modal.openModal(CityModalComponent, 'modal');
  }
  openCountry() {
    this.modal.openModal(CountryModalComponent, 'modal');
  }
  openState() {
    this.modal.openModal(StateModalComponent, 'modal');
  }
  openSub() {
    this.modal.openModal(SubDepartmentModalComponent, 'modal');
  }
  openDept() {
    this.modal.openModal(DepartmemtModalComponent, 'modal');
  }
  openBank() {
    this.modal.openModal(BanksModalComponent, 'modal');
  }
  openEmployee() {
    this.modal.openModal(EmployeeModalComponent, 'modal');
  }
  openCompany() {
    this.modal.openModal(CompanyModalComponent, 'modal');
  }
  openCategory() {
    this.modal.openModal(CartegoryModalComponent, 'modal');
  }
  openCard() {
    this.modal.openModal(CardModalComponent, 'modal');
  }
  openBranch() {
    this.modal.openModal(BranchModalComponent, 'modal');
  }
  openSpecial() {
    this.modal.openModal(SpecializationModalComponent, 'modal');
  }
  openSoc() {
    this.modal.openModal(SocModalComponent, 'modal');
  }
  openUom() {
    this.modal.openModal(UomModalComponent, 'modal');
  }
  openAloc() {
    this.modal.openModal(AlocatedSocModalComponent, 'modal');
  }
  openGroups() {
    this.modal.openModal(GroupsModalComponent, 'modal');
  }
  openItem() {
    this.modal.openModal(ItemsModalComponent, 'modal');
  }
  openOpd() {
    this.modal.openModal(OpdModalComponent, 'modal');
  }
  openNational() {
    this.modal.openModal(NationalModalComponent, 'modal');
  }
  openSale() {
    this.modal.openModal(SalesCardModalComponent, 'modal');
  }
  openDetail() {
    this.modal.openModal(OpdDetailModalComponent, 'modal');
  }
  openSetup() {
    this.modal.openModal(SetupModalComponent, 'modal');
  }
  openRefDr() {
    this.modal.openModal(RefDoctorModalComponent, 'modal')
  }
  opendrop() {
    this.modal.openModal(DropDownComponent, 'modal');
  }
  openPointment() {
    this.modal.openModal(AppointmentComponent, 'modal');
  }
  openLocalPointment() {
    this.modal.openModal(OfflineAppointmentComponent, 'modal');
  }
  bookApointment() {
    this.modal.openModal(CreateAppointmentComponent, 'modal');
  }




  closeModal() {
    this.modal.closeModal();
  }


  ngOnInit(): void {
  }

  logout() {

    if (this.role  == 'self-service user' || this.role == 'self-service consultant') {
      this.setting.logouonline()
    .subscribe(
      (resSuccess) => {

        this.data = resSuccess
        console.log(this.data);


        if (this.data.success) {
          this.router.navigate(['/login'])
          localStorage.removeItem('token');
          localStorage.removeItem('id');
          localStorage.removeItem('name');
          this._snackBar.open(this.data.message, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
        else {

          this._snackBar.open("Error try again", '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }

      },
      (resErr) => {
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
    }else {
      this.setting.logout()
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          console.log(this.data);


          if (this.data.success) {
            this.router.navigate(['/login'])
            localStorage.removeItem('token');
            localStorage.removeItem('id');
            localStorage.removeItem('name');
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
          else {

            this._snackBar.open("Error try again", '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }

        },
        (resErr) => {
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
    }
  }

}
